import * as Yup from 'yup';

import type { NumberConstraintEnum } from '@e-socna/data-layer';

import { ResolvableIdSchema } from '../schemas/resolvable-id.schema';

import { useResolvableFloatSchema } from './useResolvableFloatSchema.hook';

export const useResolvableAmountSchema = (
  numberConstraint: NumberConstraintEnum,
) => {
  const ResolvableFloatSchema = useResolvableFloatSchema(numberConstraint);

  const ResolvableAmountSchema = Yup.object().shape({
    value: ResolvableFloatSchema.required('La valeur est requise'),
    currencyId: ResolvableIdSchema.required('La devise est requise'),
  });

  return ResolvableAmountSchema;
};
